export const ANY_AIRPORT = "CUALQUIER AEROPUERTO";